/*global translate*/ 

import React, { Component } from 'react'
import ContentEditable from 'react-contenteditable'

global.isclient && require('./rxPopupUpload.css')

const { rxaget, changeColorSVG, subString } = global.rootRequire('classes/ulti')

class RxPopupUpload extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      fileListArr: rxaget(this.props, 'fileListArr', []),
      mess: '',
      acceptFile: rxaget(this.props, 'acceptFile', 'image/*,video/mp4,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.numbers,.key,.pages,.zip,.rar,.m4a,.mp3,.raw,.cr2,.nef,.orf,.sr2,.tif,.tiff,.psd,.xcf'),
    }
  }

  disableNewlines = event => {
    const keyCode = event.keyCode || event.which
    
    if (event && keyCode === 13 && event.shiftKey) {
    } else if (keyCode === 13) {
      this.onChangeSendDataFile()
      event.preventDefault()
    }
  }

  handleContentEditable = event => {
    let mess = event.target.value
    let onlyText = this.removeHTML(mess);
    this.setState({
      mess: onlyText
    })
  }

  onChangeSendDataFile() {
    this.props.onChangeDataFile({
      mess: this.state.mess
    })  
  }

  removeHTML(str){ 
    let tmp = document.createElement("DIV");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
  }

  getExtension(filename) {
    if (filename) {
      let parts = filename.split('.');
      return parts[parts.length - 1];
    } else {
      return ''
    }
  }

  render() {
    return (
      <div className='zchat-drop_rectangle'>          
        <div className='zchat-drop_rectangle_1'></div>        
        <div className='zchat-drop_rectangle_2'>        
          <div className='zchat-drop_rectangle_2_1'>
            <div className = 'zchat-drop-title'>
              {this.state.fileListArr.length + translate(' file is selected')} 

              <div className='popup_choose_leader_btn_close'>
                <img className='choose_leader_icon_close filter_img_class' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick ={()=> this.props.dropCanceBtnClick()} />
              </div>
            </div>
            <div className = 'zchat-drop-fileList'>
            {this.state.fileListArr.length > 0 ?
              <div>
                {this.state.fileListArr.map((ele,index) =>{
                  return(
                  <div key ={index}>
                    <div className ='zchat-drop-fileItem'>
                      <div className ='zchat-drop-fileImage_place'>
                        {ele.type === 'image' && 
                          <img className ='zchat-drop-fileImage' src={ele.url} alt=''/>}
                        {ele.type === 'video' && <div>
                          <video  className ='zchat-drop-fileImage'>
                            <source src={ele.url} />                              
                          </video>
                          <img className='zchat-drop-playicon' src={changeColorSVG('./images/default/static/icon-media-play-white.svg')} alt='icon-media-play-white' />
                          </div>
                        }
                        {ele.type === 'filedoc' && 
                          <img className ='zchat-drop-filedocIcon' src='./images/default/static/ic_file.svg' alt=''/>}
                      </div>
                      <div className = 'zchat-drop-fileInfo'>
                        <div className = 'zchat-drop-fileName'>{subString(ele.name, 25)}</div>
                        <div className = 'zchat-drop-filesize'>{ele.size}</div>
                        <div className = 'zchat-drop-divider'></div>
                      </div>                        
                      <div className = 'zchat-drop-icon file-edit-icon' onClick={(e) => { this.refs['file_edit_icon' + index].click()}}>

                        <input type='file' id={'file_edit_icon' + index} ref={'file_edit_icon' + index} multiple={false}
                          style={{ display: 'none' }}
                          accept={this.state.acceptFile || 'image/*,video/mp4,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.numbers,.key,.pages,.zip,.rar,.m4a,.mp3,.raw,.cr2,.nef,.orf,.sr2,.tif,.tiff,.psd,.xcf'}
                          onChange={(e) => this.props.editFileSelected(index, e.target.files)}/>
                        <img className='filter_img_class' src='./images/default/icons/icon_edit.svg' alt=''/>
                      </div>
                      <div className = 'zchat-drop-icon file-delete-icon' onClick={e => this.props.deleteFileSelected(index)}>
                        <img className='filter_img_class' src='./images/default/icons/icon-delete-chat.svg' alt=''/>
                      </div>
                    </div>
                  </div>
                )})}
              </div>
              :<div></div>}             
            </div>
            <div className='zchat-drop-footer'>
              <div className='zchat-drop-footer-box'>
                <div className='zchat-drop-inputbox'>
                  <div className='zchat-drop-chat-wrapper'>
                    <div className='zchat-drop-message-wrapper'>
                      
                      <ContentEditable
                        html={this.state.mess}
                        className='zchat-drop-message-text'
                        data-placeholder={translate('Write a message')}
                        onKeyPress={(e) => this.disableNewlines(e)}
                        onChange={(e) => this.handleContentEditable(e)}
                      />

                    </div>
                  </div>
                </div>
                <div className='zchat-drop-send'>
                  <div className='zchat-drop-footer-btn' onClick={e => this.onChangeSendDataFile()}>
                    <img src={changeColorSVG('./images/default/icons/icon-sentmess.svg')} alt='' className='neta-icons-btn neta-icon32 neta-filter_img_class'/>
                  </div>
                </div>
              </div>
            </div>
          </div>      
        </div>        
      </div>
    )
  }
}


export default RxPopupUpload